import { render, staticRenderFns } from "./setting_group_billing.vue?vue&type=template&id=99d7bbf4&scoped=true"
import script from "./setting_group_billing.vue?vue&type=script&lang=ts"
export * from "./setting_group_billing.vue?vue&type=script&lang=ts"
import style0 from "./setting_group_billing.vue?vue&type=style&index=0&id=99d7bbf4&prod&lang=scss&scoped=true"
import style1 from "./setting_group_billing.vue?vue&type=style&index=1&id=99d7bbf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d7bbf4",
  null
  
)

export default component.exports